// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/opt/buildhome/repo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import FolderOutlined from '/opt/buildhome/repo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/FolderOutlined';
import ScheduleOutlined from '/opt/buildhome/repo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ScheduleOutlined';
import WarningOutlined from '/opt/buildhome/repo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/WarningOutlined';
import SettingOutlined from '/opt/buildhome/repo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { DashboardOutlined, FolderOutlined, ScheduleOutlined, WarningOutlined, SettingOutlined };
